import {
	EnhancedEmail,
	EnhancedFacebookRounded,
	EnhancedInstagram,
	EnhancedLinkedIn,
	EnhancedPinterest,
	EnhancedTwitter
} from "../Components/Footer/Layouts/SocialBarLayout/SocialBarStyles";
import * as React from "react";

export const SocialBarSchema: Array<any> = [
	// {
	// 	icon: <EnhancedFacebookRounded />,
	// 	link: "https://business.facebook.com/latest/home?business_id=686142335881182"
	// },
	// {
	// 	icon: <EnhancedInstagram />,
	// 	link: "instagram.com"
	// },
	// {
	// 	icon: <EnhancedTwitter />,
	// 	link: "twitter.com"
	// },
	// {
	// 	icon: <EnhancedPinterest />,
	// 	link: "pintrest.com"
	// },
	{
		icon: <EnhancedLinkedIn />,
		link: "https://www.linkedin.com/in/mariamrazi/"
	},
	{
		icon: <EnhancedEmail />,
		link: "mailto:mariamrazi@gmail.com?subject=Hello&body=Just%20reaching%20out."
	},
]
